import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { selectBlocksTitles, selectHasMultipleBlocks } from '../../../store/geoentity/geoentity.selectors'
import { useAction } from '../../utils/react-redux'
import { setGeoentityTabBlocksIdx } from '../../../store/geoentity/geoentity.actions'
import s from './GeoentitytBlocksSelector.less'

const GeoentityBlocksSelector = props => {
  const [shouldRenderTitle, setRenderTitle] = useState(true)
  const shouldBeRendered = useSelector(selectHasMultipleBlocks)
  const titles = useSelector(selectBlocksTitles)
  const setIdx = useAction(setGeoentityTabBlocksIdx)

  if (!shouldBeRendered) return null

  const onChange = e => {
    setIdx(e?.target?.value ?? 0)
    setRenderTitle(false)
  }

  return (
    <div className={s.outer}>
      <select className={s.select} onChange={onChange}>
        {shouldRenderTitle && <option>Activités pour ce professionnel</option>}
        {titles.map((title, idx) => (
          <option value={idx} key={idx}>
            {title}
          </option>
        ))}
      </select>
    </div>
  )
}

export default GeoentityBlocksSelector
